<template>
  <div class="live-upload-page">
    <!-- 左右布局容器 -->
    <div class="main-layout">
      <!-- 左侧：成为主播预览区 -->
      <div class="left-panel">
        <div class="card">
          <h3 class="card-title">成为主播</h3>
          <div class="video-area">
            <div class="video-player">
              <span class="video-tag">您还未实名认证！</span>
              <!-- <button class="btn-fill">填入播放地址</button> -->
            </div>
            <div class="video-ctrl">
              <!-- <button class="btn-copy" @click="copyUrl">复制推流地址</button> -->
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧：实名认证 + 直播间资料 -->
      <div class="right-panel">
        <!-- 实名认证 -->
        <div class="card auth-card">
          <h3 class="card-title">
            <span class="step-num">1</span>
            实名认证
            <span class="status-tag" :class="authStatus">{{ authStatusText }}</span>
          </h3>
          
          <!-- 未认证状态 -->
          <div v-if="authStatus === 'unverified'" class="auth-form">
            <!-- 认证说明 -->
            <div class="auth-notice">
              <h4>主播实名认证须知</h4>
              <ul>
                <li>根据《网络直播营销管理办法》，开播前必须完成实名认证</li>
                <li>请使用本人真实身份信息，平台将严格保密</li>
                <li>认证审核时间为1-3个工作日，请耐心等待</li>
                <li>每个身份证仅限认证一个主播账号</li>
              </ul>
            </div>
            
            <div class="form-row">
              <div class="form-col">
                <label>真实姓名 <span class="required">*</span></label>
                <input v-model="authForm.realName" type="text" placeholder="请输入真实姓名，需与身份证一致" />
              </div>
              <div class="form-col">
                <label>身份证号码 <span class="required">*</span></label>
                <input v-model="authForm.idCard" type="text" placeholder="请输入18位身份证号码" maxlength="18" />
              </div>
            </div>
            
            <div class="form-row">
              <div class="form-col">
                <label>手机号码 <span class="required">*</span></label>
                <input v-model="authForm.phone" type="text" placeholder="请输入本人手机号" maxlength="11" />
              </div>
              <div class="form-col">
                <label>紧急联系人电话 <span class="required">*</span></label>
                <input v-model="authForm.emergencyPhone" type="text" placeholder="用于紧急情况联系" maxlength="11" />
              </div>
            </div>
            
            <!-- 身份证上传 -->
            <div class="idcard-upload">
              <label>身份证照片上传 <span class="required">*</span></label>
              <div class="upload-row">
                <!-- 正面 -->
                <div class="idcard-frame">
                  <input 
                    type="file" 
                    ref="idCardFrontInput" 
                    accept="image/*" 
                    style="display: none;" 
                    @change="handleIdCardChange($event, 'front')"
                  />
                  <div v-if="!idCardFront" class="upload-placeholder" @click="triggerIdCardUpload('front')">
                    <i class="el-icon-plus"></i>
                    <span>身份证正面</span>
                    <small>点击上传</small>
                  </div>
                  <img v-else :src="idCardFront" class="idcard-preview" @click="triggerIdCardUpload('front')" />
                </div>
                <!-- 反面 -->
                <div class="idcard-frame">
                  <input 
                    type="file" 
                    ref="idCardBackInput" 
                    accept="image/*" 
                    style="display: none;" 
                    @change="handleIdCardChange($event, 'back')"
                  />
                  <div v-if="!idCardBack" class="upload-placeholder" @click="triggerIdCardUpload('back')">
                    <i class="el-icon-plus"></i>
                    <span>身份证反面</span>
                    <small>点击上传</small>
                  </div>
                  <img v-else :src="idCardBack" class="idcard-preview" @click="triggerIdCardUpload('back')" />
                </div>
                <!-- 手持 -->
                <div class="idcard-frame">
                  <input 
                    type="file" 
                    ref="idCardHoldInput" 
                    accept="image/*" 
                    style="display: none;" 
                    @change="handleIdCardChange($event, 'hold')"
                  />
                  <div v-if="!idCardHold" class="upload-placeholder" @click="triggerIdCardUpload('hold')">
                    <i class="el-icon-plus"></i>
                    <span>手持身份证</span>
                    <small>点击上传</small>
                  </div>
                  <img v-else :src="idCardHold" class="idcard-preview" @click="triggerIdCardUpload('hold')" />
                </div>
              </div>
              <div class="upload-tips">
                <p><i class="el-icon-warning-outline"></i> 照片要求：清晰、完整、无遮挡，文字可见，四角完整</p>
                <p><i class="el-icon-warning-outline"></i> 手持照要求：本人手持身份证，面部清晰，证件信息可见</p>
                <p><i class="el-icon-warning-outline"></i> 支持格式：JPG、PNG，单张不超过5MB</p>
              </div>
            </div>
            
            <button 
              class="btn-auth" 
              :class="{ 'btn-auth-disabled': !canSubmitAuth }"
              :disabled="!canSubmitAuth"
              @click="submitAuth"
            >
              提交认证
            </button>
          </div>
          
          <!-- 认证中状态 -->
          <div v-else-if="authStatus === 'pending'" class="auth-status">
            <div class="status-icon">⏳</div>
            <p class="status-text">实名认证审核中</p>
            <p class="status-desc">预计1-3个工作日完成审核，请耐心等待</p>
            <div class="status-detail">
              <p>提交时间：{{ submitTime }}</p>
              <p>审核结果将通过短信通知您</p>
            </div>
          </div>
          
          <!-- 已认证状态 -->
          <div v-else-if="authStatus === 'verified'" class="auth-status success">
            <div class="status-icon">✓</div>
            <p class="status-text">实名认证已通过</p>
            <p class="status-desc">{{ authForm.realName }} | {{ maskIdCard(authForm.idCard) }}</p>
            <div class="status-detail">
              <p>认证时间：{{ verifyTime }}</p>
              <p>您现在可以设置直播间资料了</p>
            </div>
          </div>
        </div>

        <!-- 直播间资料（仅认证通过后显示） -->
        <template v-if="authStatus === 'verified'">
          <div class="card">
            <h3 class="card-title">
              <span class="step-num">2</span>
              直播间资料
            </h3>
            
            <div class="info-form">
              <div class="form-row">
                <div class="form-col">
                  <label>主播昵称</label>
                  <input v-model="form.nickname" type="text" />
                </div>
                <div class="form-col">
                  <label>直播间名称</label>
                  <input v-model="form.roomName" type="text" />
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-col">
                  <label>直播分类</label>
                  <div class="custom-select" @click="showCategoryDropdown = !showCategoryDropdown">
                    <span class="select-text">{{ form.category ? getCategoryLabel(form.category) : '请选择' }}</span>
                    <i class="el-icon-arrow-down"></i>
                    <div v-if="showCategoryDropdown" class="dropdown-menu">
                      <div
                        v-for="item in categoryList"
                        :key="item.value"
                        class="dropdown-item"
                        @click.stop="selectCategory(item.value)"
                      >
                        {{ item.label }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-col">
                  <label>直播间ID</label>
                  <input v-model="form.roomId" type="text" readonly />
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-col full">
                  <label>直播间公告</label>
                  <input v-model="form.notice" type="text" placeholder="填写直播间公告，让观众更了解你" />
                </div>
              </div>
            </div>
          </div>

          <!-- 直播间封面 -->
          <div class="card">
            <h3 class="card-title">
              <span class="step-num">3</span>
              直播间封面
              <span class="tip">请根据直播比例选择图片上传</span>
            </h3>
            <div class="cover-box">
              <!-- 竖版封面 -->
              <div class="upload-frame frame-portrait">
                <input 
                  type="file" 
                  ref="fileInputV" 
                  accept="image/*" 
                  style="display: none;" 
                  @change="handleFileChange($event, 'portrait')"
                />
                <img v-if="coverPortrait" :src="coverPortrait" class="cover-preview" />
                <button v-else class="btn-upload" @click="triggerUpload('portrait')">上传图片</button>
                <div v-if="coverPortrait" class="cover-actions">
                  <button class="btn-reupload" @click="triggerUpload('portrait')">重新上传</button>
                </div>
              </div>
              <!-- 横版封面 -->
              <div class="upload-frame frame-landscape">
                <input 
                  type="file" 
                  ref="fileInputH" 
                  accept="image/*" 
                  style="display: none;" 
                  @change="handleFileChange($event, 'landscape')"
                />
                <img v-if="coverLandscape" :src="coverLandscape" class="cover-preview" />
                <button v-else class="btn-upload" @click="triggerUpload('landscape')">上传图片</button>
                <div v-if="coverLandscape" class="cover-actions">
                  <button class="btn-reupload" @click="triggerUpload('landscape')">重新上传</button>
                </div>
              </div>
            </div>
          </div>

          <!-- 提交 -->
          <div class="submit-box">
            <button 
              class="btn-submit" 
              :class="{ 'btn-submit-disabled': isSubmitting }"
              :disabled="isSubmitting"
              @click="submit"
            >
              {{ isSubmitting ? '审核中预计3~5个工作日' : '提交资料' }}
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LiveUploadPage',
  data() {
    return {
      // 实名认证状态: unverified-未认证 pending-审核中 verified-已认证
      authStatus: 'unverified',
      showCategoryDropdown: false,
      // 实名认证表单
      authForm: {
        realName: '',
        idCard: '',
        phone: '',
        emergencyPhone: ''
      },
      // 提交时间
      submitTime: '',
      verifyTime: '',
      // 身份证照片
      idCardFront: '',
      idCardBack: '',
      idCardHold: '',
      // 直播间表单
      form: {
        nickname: '',
        roomName: '',
        category: '',
        roomId: '3269',
        notice: ''
      },
      // 封面图片
      coverPortrait: '',
      coverLandscape: '',
      // 提交状态
      isSubmitting: false,
      categoryList: [
        { label: '音乐', value: 'music' },
        { label: '舞蹈', value: 'dance' },
        { label: '乐器', value: 'instrument' },
        { label: '脱口秀', value: 'talkshow' },
        { label: '二次元', value: 'anime' },
        { label: '颜值', value: 'beauty' },
        { label: '才艺', value: 'talent' },
        { label: '生活方式', value: 'lifestyle' },
        { label: '团舞', value: 'groupdance' },
        { label: '翻唱', value: 'cover' }
      ]
    }
  },
  computed: {
    // 认证状态文字
    authStatusText() {
      const map = {
        'unverified': '未认证',
        'pending': '审核中',
        'verified': '已认证'
      }
      return map[this.authStatus] || '未认证'
    },
    // 提交按钮文字
    submitBtnText() {
      if (this.authStatus !== 'verified') return '请先完成实名认证'
      if (this.isSubmitting) return '审核中预计3~5个工作日'
      return '提交资料'
    },
    // 是否可以提交实名认证
    canSubmitAuth() {
      // 验证真实姓名
      if (!this.authForm.realName.trim()) return false
      // 验证身份证号
      if (!this.authForm.idCard.trim()) return false
      const idCardReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (!idCardReg.test(this.authForm.idCard)) return false
      // 验证手机号
      if (!this.authForm.phone.trim()) return false
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(this.authForm.phone)) return false
      // 验证紧急联系人
      if (!this.authForm.emergencyPhone.trim()) return false
      if (!phoneReg.test(this.authForm.emergencyPhone)) return false
      // 验证身份证照片
      if (!this.idCardFront || !this.idCardBack || !this.idCardHold) return false
      return true
    }
  },
  methods: {
    // 获取分类名称
    getCategoryLabel(value) {
      const item = this.categoryList.find(i => i.value === value)
      return item ? item.label : ''
    },
    // 选择分类
    selectCategory(value) {
      this.form.category = value
      this.showCategoryDropdown = false
    },
    // 复制推流地址
    copyUrl() {
      this.$message.success('推流地址已复制')
    },
    // 开始直播
    startLive() {
      this.$emit('startLive')
    },
    // 触发身份证上传
    triggerIdCardUpload(type) {
      if (type === 'front') {
        this.$refs.idCardFrontInput.click()
      } else if (type === 'back') {
        this.$refs.idCardBackInput.click()
      } else {
        this.$refs.idCardHoldInput.click()
      }
    },
    // 处理身份证照片选择
    handleIdCardChange(event, type) {
      const file = event.target.files[0]
      if (!file) return
      
      // 验证文件类型
      if (!file.type.startsWith('image/')) {
        this.$message.error('请上传图片文件')
        return
      }
      
      // 验证文件大小（最大5MB）
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不能超过5MB')
        return
      }
      
      // 读取并预览图片
      const reader = new FileReader()
      reader.onload = (e) => {
        if (type === 'front') {
          this.idCardFront = e.target.result
        } else if (type === 'back') {
          this.idCardBack = e.target.result
        } else {
          this.idCardHold = e.target.result
        }
        this.$message.success('图片上传成功')
      }
      reader.readAsDataURL(file)
      
      // 清空input，允许重复选择同一文件
      event.target.value = ''
    },
    // 提交实名认证
    submitAuth() {
      // 验证真实姓名
      if (!this.authForm.realName.trim()) {
        this.$message.error('请输入真实姓名')
        return
      }
      // 验证身份证号
      if (!this.authForm.idCard.trim()) {
        this.$message.error('请输入身份证号码')
        return
      }
      // 简单身份证格式验证
      const idCardReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (!idCardReg.test(this.authForm.idCard)) {
        this.$message.error('请输入正确的18位身份证号码')
        return
      }
      // 验证手机号
      if (!this.authForm.phone.trim()) {
        this.$message.error('请输入手机号码')
        return
      }
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(this.authForm.phone)) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      // 验证紧急联系人
      if (!this.authForm.emergencyPhone.trim()) {
        this.$message.error('请输入紧急联系人电话')
        return
      }
      if (!phoneReg.test(this.authForm.emergencyPhone)) {
        this.$message.error('请输入正确的紧急联系人电话')
        return
      }
      // 验证身份证照片
      if (!this.idCardFront || !this.idCardBack || !this.idCardHold) {
        this.$message.error('请上传完整的身份证照片（正面、反面、手持）')
        return
      }

      // 记录提交时间
      this.submitTime = new Date().toLocaleString('zh-CN')
      
      this.$message.success('实名认证提交成功，正在审核中')
      this.authStatus = 'pending'
      
      // 模拟审核通过（实际应该等待后端回调）
      // setTimeout(() => {
      //   this.authStatus = 'verified'
      //   this.verifyTime = new Date().toLocaleString('zh-CN')
      //   this.$message.success('实名认证已通过')
      // }, 3000)
    },
    // 隐藏身份证号
    maskIdCard(idCard) {
      if (!idCard || idCard.length !== 18) return idCard
      return idCard.slice(0, 4) + '**********' + idCard.slice(14)
    },
    // 触发封面上传
    triggerUpload(type) {
      if (this.authStatus !== 'verified') {
        this.$message.warning('请先完成实名认证')
        return
      }
      if (type === 'portrait') {
        this.$refs.fileInputV.click()
      } else {
        this.$refs.fileInputH.click()
      }
    },
    // 处理封面文件选择
    handleFileChange(event, type) {
      const file = event.target.files[0]
      if (!file) return
      
      // 验证文件类型
      if (!file.type.startsWith('image/')) {
        this.$message.error('请上传图片文件')
        return
      }
      
      // 验证文件大小（最大5MB）
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不能超过5MB')
        return
      }
      
      // 读取并预览图片
      const reader = new FileReader()
      reader.onload = (e) => {
        if (type === 'portrait') {
          this.coverPortrait = e.target.result
        } else {
          this.coverLandscape = e.target.result
        }
        this.$message.success('图片上传成功')
      }
      reader.readAsDataURL(file)
      
      // 清空input，允许重复选择同一文件
      event.target.value = ''
    },
    // 提交直播间资料
    submit() {
      if (this.authStatus !== 'verified') {
        this.$message.warning('请先完成实名认证')
        return
      }
      if (!this.form.nickname.trim()) {
        this.$message.error('请输入主播昵称')
        return
      }
      if (!this.form.roomName.trim()) {
        this.$message.error('请输入直播间名称')
        return
      }
      if (!this.form.category) {
        this.$message.error('请选择直播分类')
        return
      }
      this.$message.success('资料提交成功，审核需要3~5个工作日，请耐心等待')
      // 清空表单数据
      this.form.nickname = ''
      this.form.roomName = ''
      this.form.category = ''
      this.form.notice = ''
      // 清空封面图片
      this.coverPortrait = ''
      this.coverLandscape = ''
      // 设置提交状态为审核中
      this.isSubmitting = true
    }
  }
}
</script>

<style scoped lang="scss">
// B站直播风格令牌：粉 #fb7299 / hover #ff85ad / 浅粉 #fff0f5 #fff7fa
// 文字 #18191c #61666d #9499a0 / 边框 #e3e5e7 / 分割 #f1f2f3 / 底 #f4f4f5
// 卡片 radius 8 / 输入按钮 radius 6 / 标签 radius 4 / 过渡 0.2s / 禁止 box-shadow

// 页面容器（由外层 .content 滚动，禁止 100vh 撑高）
.live-upload-page {
  min-height: 100%;
  background: #f4f4f5;
  padding: 20px;
  box-sizing: border-box;
}

// 左右布局
.main-layout {
  display: flex;
  gap: 16px;
  max-width: 1345px;
  margin: 0 auto;
  align-items: flex-start;
}

// 左侧面板
.left-panel {
  width: 58%;
  flex-shrink: 0;

  .card {
    display: flex;
    flex-direction: column;
    margin-bottom: 0;

    .card-title {
      flex-shrink: 0;
    }

    .video-area {
      display: flex;
      flex-direction: column;

      .video-player {
        margin-bottom: 0;
      }
    }
  }
}

// 右侧面板
.right-panel {
  flex: 1;
  min-width: 0;
}

// 白色卡片
.card {
  background: #fff;
  border: 1px solid #e3e5e7;
  border-radius: 8px;
  padding: 20px 22px;
  margin-bottom: 16px;
  transition: opacity 0.2s ease;

  &.disabled {
    opacity: 0.6;
    pointer-events: none;
  }
}

// 卡片标题
.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #18191c;
  margin: 0 0 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  .step-num {
    width: 22px;
    height: 22px;
    background: #fb7299;
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    flex-shrink: 0;
  }

  .tip {
    font-size: 12px;
    color: #9499a0;
    font-weight: normal;
    margin-left: 4px;
  }

  .status-tag {
    font-size: 12px;
    padding: 2px 9px;
    border-radius: 4px;
    font-weight: normal;
    margin-left: auto;

    &.unverified {
      background: #fff3e5;
      color: #ff9500;
    }

    &.pending {
      background: #eaf2ff;
      color: #4a8cff;
    }

    &.verified {
      background: #e6f9ef;
      color: #23ad68;
    }
  }

  .lock-tip {
    font-size: 12px;
    color: #9499a0;
    font-weight: normal;
    margin-left: auto;
  }
}

// 视频预览区域
.video-area {
  .video-player {
    width: 100%;
    aspect-ratio: 16 / 16;
    background: #000;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 12px;
    overflow: hidden;

    .video-tag {
      padding: 6px 14px;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 6px;
      color: rgba(255, 255, 255, 0.85);
      font-size: 14px;
    }

    .btn-fill {
      position: absolute;
      bottom: 24px;
      padding: 8px 24px;
      background: rgba(255, 255, 255, 0.18);
      border: 1px solid rgba(255, 255, 255, 0.35);
      border-radius: 6px;
      color: #fff;
      font-size: 13px;
      cursor: pointer;
      transition: background 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.28);
      }
    }
  }

  .video-ctrl {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .btn-copy {
      padding: 8px 20px;
      background: #fff;
      border: 1px solid #e3e5e7;
      border-radius: 6px;
      color: #61666d;
      font-size: 13px;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        border-color: #fb7299;
        color: #fb7299;
      }
    }

    .btn-start {
      padding: 9px 28px;
      background: #fb7299;
      border: none;
      border-radius: 6px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      transition: background 0.2s ease;

      &:hover {
        background: #ff85ad;
      }
    }
  }
}

// 实名认证卡片
.auth-card {
  display: flex;
  flex-direction: column;

  .card-title {
    flex-shrink: 0;
  }

  .auth-form {
    display: flex;
    flex-direction: column;
  }
}

// 认证须知
.auth-notice {
  background: #fff7e8;
  border: 1px solid #ffe2b8;
  border-radius: 6px;
  padding: 14px 18px;
  margin-bottom: 20px;

  h4 {
    font-size: 13px;
    color: #18191c;
    margin: 0 0 8px;
    font-weight: 600;
  }

  ul {
    list-style: disc;
    margin: 0;
    padding-left: 18px;

    li {
      font-size: 13px;
      color: #61666d;
      line-height: 1.8;
    }
  }
}

// 实名认证表单
.auth-form {
  .form-row {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
  }

  .form-col {
    flex: 1;

    label {
      display: block;
      font-size: 13px;
      color: #61666d;
      margin-bottom: 8px;

      .required {
        color: #f3526f;
        margin-left: 2px;
      }
    }

    input {
      width: 100%;
      padding: 9px 12px;
      border: 1px solid #e3e5e7;
      border-radius: 6px;
      font-size: 13px;
      color: #18191c;
      background: #fff;
      outline: none;
      box-sizing: border-box;
      transition: border-color 0.2s ease;

      &:focus {
        border-color: #fb7299;
      }

      &::placeholder {
        color: #9499a0;
      }
    }
  }
}

// 身份证上传
.idcard-upload {
  margin-bottom: 16px;

  label {
    display: block;
    font-size: 13px;
    color: #61666d;
    margin-bottom: 12px;

    .required {
      color: #f3526f;
      margin-left: 2px;
    }
  }

  .upload-row {
    display: flex;
    gap: 12px;
  }

  .idcard-frame {
    flex: 1;
    aspect-ratio: 1.58;
    border: 1px dashed #c9ccd0;
    border-radius: 6px;
    background: #fafafa;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.2s ease;

    &:hover {
      border-color: #fb7299;
      background: #fff7fa;
    }

    .upload-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      color: #61666d;

      i {
        font-size: 22px;
        color: #fb7299;
      }

      span {
        font-size: 13px;
      }

      small {
        font-size: 11px;
        color: #9499a0;
      }
    }

    .idcard-preview {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .upload-tips {
    margin-top: 12px;
    padding: 12px 14px;
    background: #fafafa;
    border-radius: 6px;

    p {
      font-size: 12px;
      color: #9499a0;
      margin: 0 0 6px;
      display: flex;
      align-items: center;
      gap: 6px;

      &:last-child {
        margin-bottom: 0;
      }

      i {
        color: #ffb02e;
      }
    }
  }
}

// 认证状态
.auth-status {
  text-align: center;
  padding: 36px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .status-icon {
    font-size: 48px;
    margin-bottom: 12px;
  }

  .status-text {
    font-size: 16px;
    font-weight: 600;
    color: #18191c;
    margin: 0 0 8px;
  }

  .status-desc {
    font-size: 13px;
    color: #61666d;
    margin: 0 0 16px;
  }

  .status-detail {
    background: #fafafa;
    border-radius: 6px;
    padding: 14px 20px;
    margin-top: 8px;

    p {
      font-size: 13px;
      color: #9499a0;
      margin: 0 0 6px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &.success {
    .status-icon {
      color: #23ad68;
    }
  }
}

// 提交认证主按钮
.btn-auth {
  width: 100%;
  padding: 11px;
  background: #fb7299;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: auto;
  transition: background 0.2s ease;

  &:hover:not(:disabled) {
    background: #ff85ad;
  }

  &.btn-auth-disabled {
    background: #e3e5e7;
    color: #9499a0;
    cursor: not-allowed;
  }
}

// 直播间资料表单
.info-form {
  .form-row {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .form-col {
    flex: 1;

    &.full {
      flex: 1;
    }

    label {
      display: block;
      font-size: 13px;
      color: #61666d;
      margin-bottom: 8px;
    }

    input {
      width: 100%;
      padding: 9px 12px;
      border: 1px solid #e3e5e7;
      border-radius: 6px;
      font-size: 13px;
      color: #18191c;
      background: #fff;
      outline: none;
      box-sizing: border-box;
      transition: border-color 0.2s ease;

      &:focus {
        border-color: #fb7299;
      }

      &[readonly] {
        background: #f7f7f8;
        color: #9499a0;
      }

      &:disabled {
        background: #f7f7f8;
        color: #9499a0;
        cursor: not-allowed;
      }
    }

    // 自定义下拉框（不用阴影，靠描边与底色区分层级）
    .custom-select {
      position: relative;
      width: 100%;
      padding: 9px 12px;
      border: 1px solid #e3e5e7;
      border-radius: 6px;
      font-size: 13px;
      color: #18191c;
      background: #fff;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      transition: border-color 0.2s ease;

      &:hover {
        border-color: #fb7299;
      }

      .select-text {
        color: #18191c;
      }

      .el-icon-arrow-down {
        color: #9499a0;
        font-size: 12px;
      }

      .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        margin-top: 4px;
        background: #fff;
        border: 1px solid #e3e5e7;
        border-radius: 6px;
        z-index: 100;
        max-height: 200px;
        overflow-y: auto;

        .dropdown-item {
          padding: 9px 14px;
          font-size: 13px;
          color: #18191c;
          cursor: pointer;
          transition: background 0.2s ease;

          &:hover {
            background: #f7f7f8;
            color: #fb7299;
          }

          &:first-child {
            border-radius: 6px 6px 0 0;
          }

          &:last-child {
            border-radius: 0 0 6px 6px;
          }
        }
      }

      &.disabled {
        background: #f7f7f8;
        color: #9499a0;
        cursor: not-allowed;
      }
    }
  }
}

// 封面上传区域
.cover-box {
  border: 1px solid #e3e5e7;
  border-radius: 8px;
  padding: 28px 32px;
  display: flex;
  gap: 40px;
  justify-content: center;
  align-items: center;
  background: #fafafa;

  .upload-frame {
    border: 1px dashed #c9ccd0;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fff;
    position: relative;
    overflow: hidden;
    transition: border-color 0.2s ease;

    &:hover {
      border-color: #fb7299;
    }

    &.frame-portrait {
      width: 180px;
      height: 270px;
    }

    &.frame-landscape {
      width: 320px;
      height: 180px;
    }

    .cover-preview {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .cover-actions {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
    }

    .btn-upload {
      padding: 9px 32px;
      background: #fb7299;
      border: none;
      border-radius: 6px;
      color: #fff;
      font-size: 13px;
      cursor: pointer;
      transition: background 0.2s ease;

      &:hover:not(:disabled) {
        background: #ff85ad;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }

    .btn-reupload {
      padding: 6px 18px;
      background: rgba(251, 114, 153, 0.92);
      border: none;
      border-radius: 6px;
      color: #fff;
      font-size: 12px;
      cursor: pointer;
      transition: background 0.2s ease;

      &:hover {
        background: #fb7299;
      }
    }
  }
}

// 提交资料主按钮
.submit-box {
  display: flex;
  justify-content: center;
  padding: 4px 0 8px;

  .btn-submit {
    padding: 11px 56px;
    background: #fb7299;
    border: none;
    border-radius: 6px;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover:not(:disabled) {
      background: #ff85ad;
    }

    &.btn-submit-disabled {
      background: #e3e5e7;
      color: #9499a0;
      cursor: not-allowed;

      &:hover {
        background: #e3e5e7;
      }
    }
  }
}
</style>